module.exports = __webpack_public_path__ + "static/media/pietro-perugino-fixed.9f6bfc2a.jpg";